import React, { memo } from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import PickupDropoffSelect, {
  IPickupDropoffSelectProps,
  IPickupDropoffSelectValue,
} from 'transfix-ui/components/PickupDropoffSelect/PickupDropoffSelect'

type IBaseControllerProps = ControllerProps<React.ComponentType<IPickupDropoffSelectProps>>

export interface IControlledPickupDropoffSelectProps
  extends Pick<IBaseControllerProps, 'control' | 'name' | 'defaultValue'> {
  PickupDropoffSelectProps?: Omit<IPickupDropoffSelectProps, 'onChange' | 'onSwap' | 'value'>
}

const ControlledPickupDropoffSelect = memo<IControlledPickupDropoffSelectProps>(
  ({ PickupDropoffSelectProps, control, defaultValue, name }) => {
    return (
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ onChange, value }) => {
          const changeHandler: IPickupDropoffSelectProps['onChange'] = (key, newVal) => {
            if (value) {
              onChange({ ...value, [key]: newVal })
            } else {
              onChange({ [key]: newVal })
            }
          }

          const swapHandler: IPickupDropoffSelectProps['onSwap'] = () => {
            if (value) {
              const { dropoff, dropoffRadius, pickup, pickupRadius } =
                (value as IPickupDropoffSelectValue) || {}
              onChange({
                pickup: dropoff,
                pickupRadius: dropoffRadius,
                dropoff: pickup,
                dropoffRadius: pickupRadius,
              })
            }
          }

          return (
            <PickupDropoffSelect
              value={value}
              onChange={changeHandler}
              onSwap={swapHandler}
              {...PickupDropoffSelectProps}
            />
          )
        }}
      />
    )
  }
)

export default ControlledPickupDropoffSelect
